import styled from "styled-components";

export const SettingContainer = styled.div`
  width: 100%;
  height: 100%;
  .viewer {
    height: 100%;
    .label {
      font-weight: 700;
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 35px;
      span {
        font-size: 28px;
      }
      button {
        background: #255dac;
        color: #fff;
        font-size: 14px;
        width: 130px;
        border: none;
        height: 100%;
      }
    }
  }
  .slideWrapper {
    flex-flow: row nowrap;
    display: flex;
    flex: 1;
    width: 100%;
    transition: transform 0.5s ease;
    height: 100%;
    overflow: hidden;
    margin: auto;
    position: relative;
    .slideContent {
      flex: 0 0 50%;
      transform: translateX(0);
      flex-basis: 100%;
      flex-shrink: 0;
      transition: 1s;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      overflow: hidden;
    }
  }
  @media screen and (max-width: 1050px) {
  }
  @media screen and (max-width: 767px) {
  }
`;

export const SettingContent = styled.div`
  height: 100%;
  letter-spacing: -1px;
  button {
    border: none;
    background: transparent;
  }
  svg {
    margin: 0;
    display: block;
  }
  .contents {
    height: calc(100% - 70px);
  }
`;

export const InfoContaienr = styled.div`
  padding: 0px 30px;
  border-bottom: 1px solid rgb(102, 102, 102);
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .heading {
    display: flex;
    font-size: 20px;
    font-weight: 700;
    align-items: center;
    gap: 10px;
    button {
      margin-left: 10px;
    }
  }
  strong {
    color: #255dac;
    font-weight: 700;
  }
  button {
    padding: 0 10px;
    min-width: 50px;
    font-weight: 700;
    border-radius: 5px;
    border: none;
    height: 33px;
    font-size: 14px;
    margin-left: 10px;
    transition: 0.3s;
    svg {
      display: block;
      margin: auto;
    }
    &.delete {
      background: #333;
      color: #fff;
    }
    &.cancel,
    &.toggle,
    &.exit {
      background: #dee5ea;
      color: #5f6970;
    }
    &.submit,
    &.add {
      background: #255dac;
      color: #fff;
    }
    &.undelete {
      background: #efefef;
    }
    &.sync {
      background: #5f6970;
      color: #fff;
    }
    &:first-child {
      margin-left: 0;
    }
  }
  .search {
    input[type="text"] {
      width: 240px;
    }
    button {
      margin-left: 0;
    }
  }
  @media screen and (max-width: 767px) {
    height: auto;
    flex-wrap: wrap;
    padding: 10px 20px;
    gap: 10px;
    button {
      height: 30px;
    }
    .heading {
      font-size: 16px;
      justify-content: space-between;
    }
    .search {
      width: 100%;
      input[type="text"] {
        width: calc(100% - 60px);
      }
    }
  }
`;

export const ProductListContainer = styled.div`
  height: 100%;
  .contents {
    height: 100%;
    padding: 15px;
    font-size: 16px;
    height: calc(100% - 70px);
    > ul {
      padding: 15px;
      max-height: calc(100% - 43px);
      margin-top: 10px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #5a5a5a;
        border-radius: 10px;
        border: 2px solid #d9d9d9;
      }
      &::-webkit-scrollbar-track {
        background-color: #d9d9d9;
        border-radius: 10px;
      }
    }
    > ul > li {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      gap: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        width: 80px;
        height: 80px;
        object-fit: cover;
        background: #efefef;
        border-radius: 5px;
        &.soldout {
          filter: grayscale(1);
        }
      }
      .productInfo {
        width: calc(100% - 290px);
        .tags {
          margin-bottom: 3px;
          span {
            font-size: 14px;
            padding: 2px 5px;
            border-radius: 5px;
            color: rgb(85, 85, 85);
            background: rgb(238, 238, 238);
            &:nth-child(1) {
              margin-right: 5px;
            }
            &.inactive {
              background: rgb(51, 51, 51);
              color: rgb(255, 255, 255);
            }
          }
        }
        > span {
          max-width: 100%;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 3px;
          &:nth-of-type(1) {
            font-weight: 700;
            font-size: 18px;
          }
          &:nth-of-type(2) {
            color: #555;
          }
          &:nth-of-type(3) {
            color: #555;
            font-weight: 700;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .contents > ul > li .productInfo {
      span:first-child {
        font-size: 16px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .contents {
      font-size: 14px;
      max-height: calc(100% - 81px);
      > ul {
        > li {
          display: block;
          position: relative;
          margin-bottom: 25px;
          img {
            display: block;
            margin: 10px 0;
          }
          .productInfo {
            width: 100%;
          }
          > div:last-child {
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
    }
  }
`;

export const OptionFormContainer = styled.div`
  height: 100%;
  font-size: 16px;
  .contents {
    padding: 15px;
    > ul {
      padding: 15px;
      li {
        &.options {
          align-items: flex-start;
          .tit {
            height: 40px;
          }
          .cont > ul > li {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 0;
            }
            &.header {
              font-weight: 700;
              span {
                &:nth-child(1) {
                  width: 130px;
                }
                &:nth-child(2),
                &:nth-child(3),
                &:nth-child(4),
                &:nth-child(5) {
                  width: calc((100% - 170px) / 4);
                }
              }
            }
            > div {
              &:nth-child(1) {
                width: 130px;
                height: 40px;
                flex-direction: row-reverse;
                .status {
                  width: 90px;
                }
                .actions {
                  width: 40px;
                  border-left: none;
                  border-right: 1px solid #e8e8e8;
                }
                .context-status {
                  left: 100%;
                  transform: translateX(-100%) translateY(5px);
                }
              }
              &:nth-child(2),
              &:nth-child(3),
              &:nth-child(4),
              &:nth-child(5) {
                width: calc((100% - 170px) / 4);
              }
              &:nth-child(5) {
                display: flex;
                align-items: center;
                overflow: hidden;
                border: 1px solid rgb(232, 232, 232);
                border-radius: 10px;
                height: 40px;
                input[type="text"] {
                  border: none;
                  width: calc(100% - 40px);
                  &:focus {
                    border: none !important;
                  }
                }
                button {
                  background: rgb(232, 232, 232);
                  width: 40px;
                  height: 40px;
                  svg {
                    margin: auto;
                  }
                }
              }
            }
          }
          .add {
            margin-top: 20px;
            display: flex;
            align-items: center;
            color: #255dac;
            gap: 5px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .contents {
      padding: 15px;
      > ul {
        padding: 15px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 14px;
    .contents {
      padding: 10px;
      height: calc(100% - 51px);
      > ul {
        padding: 10px;
        li.options .cont > ul > li {
          flex-wrap: wrap;
          gap: 5px;
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
          &.header {
            span {
              &:nth-child(1),
              &:nth-child(2),
              &:nth-child(3),
              &:nth-child(4),
              &:nth-child(5) {
                width: 100%;
              }
            }
          }
          > div {
            &:nth-child(1) {
              button.status {
                width: calc(100% - 40px);
              }
            }
            &:nth-child(1),
            &:nth-child(2),
            &:nth-child(3),
            &:nth-child(4),
            &:nth-child(5) {
              width: 100%;
            }
          }
        }
      }
    }
  }
`;

export const FormContainer = styled.ul`
  padding: 30px;
  transition: 0.3s;
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #5a5a5a;
    border-radius: 10px;
    border: 2px solid #d9d9d9;
  }
  &::-webkit-scrollbar-track {
    background-color: #d9d9d9;
    border-radius: 10px;
  }
  > li {
    display: flex;
    margin-bottom: 20px;
    gap: 20px;
    align-items: center;
    &.status {
      .switches.cont span {
        width: 100px;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
    .tit {
      font-weight: 700;
      width: 130px;
      color: #838383;
    }
    .cont {
      width: calc(100% - 150px);
      input[type="text"],
      input[type="number"],
      .selected,
      textarea {
        border: 1px solid #e8e8e8;
        height: 40px;
        padding: 0 20px;
        width: 100%;
        border-radius: 10px;
        letter-spacing: -1px;
        resize: none;
        &:focus {
          border: 1px solid #e8e8e8 !important;
          box-shadow: none;
          outline: none;
        }
        input[type="number"] {
          &::-webkit-outer-spin-button,
          &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
        }
      }
      > textarea {
        height: 200px;
        padding: 20px;
      }
      &.multiCheckbox {
        display: flex;
        align-items: center;
        gap: 10px;
        label {
          width: 40px;
          height: 40px;
          border: 1px solid #e8e8e8;
          border-radius: 5px;
          overflow: hidden;
          input[type="checkbox"] {
            display: none;
            &:checked ~ span {
              background: rgb(222, 229, 234);
              color: rgb(95, 105, 112);
            }
          }
          span {
            font-weight: 700;
            display: block;
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: 40px;
            transition: 0.3s;
          }
        }
      }
      &.switches {
        display: flex;
        align-items: center;
        text-align: center;
        width: fit-content;
        font-weight: 700;
        overflow: hidden;
        span {
          width: 150px;
          height: 40px;
          line-height: 40px;
          border-top: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
          transition: 0.2s;
          &:first-child {
            border-left: 1px solid #e8e8e8;
            border-radius: 10px 0 0 10px;
          }
          &:not(:first-child) {
            border-left: 1px solid #e8e8e8;
          }
          &:last-child {
            border-right: 1px solid #e8e8e8;
            border-radius: 0 10px 10px 0;
          }
          &.active {
            background: #255dac;
            border-color: #255dac;
            color: #fff;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1400px) {
    padding: 20px;
    > li {
      display: block;
      &.status .switches.cont span {
        width: calc(100% / 3);
      }
      .cont {
        margin-top: 10px;
        width: 100%;
        &.switches {
          width: 100%;
          span {
            width: 50%;
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    > li .cont {
      &.switches {
        font-size: 14px;
        font-weight: normal;
      }
      &.multiCheckbox {
        gap: 5px;
        label {
          flex: 1;
        }
      }
      textarea {
        padding: 10px;
        height: 150px;
        border-radius: 5px;
      }
      input[type="text"],
      input[type="number"],
      .selected {
        padding: 0 10px;
        border-radius: 5px;
      }
    }
  }
`;

export const ProductFormContainer = styled.div`
  height: 100%;
  font-size: 16px;
  .ck-editor__editable {
    min-height: 250px !important;
    overflow-y: auto;
  }
  .contents {
    position: relative;
    display: flex;
    > ul {
      width: calc(100% - 300px);
      overflow-x: hidden;
      li {
        &.media .cont {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          > div,
          label {
            width: 100px;
            height: 100px;
            border-radius: 5px;
            border: 1px solid #e8e8e8;
            position: relative;
          }
          button {
            position: absolute;
            top: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            border: none;
            font-size: 16px;
            svg {
              display: block;
              margin: 0;
            }
          }
          img,
          video {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          label {
            font-size: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #838383;
            svg {
              display: block;
              margin: 0;
            }
          }
          input[type="file"] {
            display: none;
          }
        }
        &.quantity .cont {
          display: flex;
          align-items: center;
          border: 1px solid rgb(232, 232, 232);
          height: 40px;
          border-radius: 10px;
          overflow: hidden;
          input[type="text"] {
            width: calc(100% - 40px);
            border: none !important;
            &:focus {
              border: none !important;
            }
          }
          button {
            width: 40px;
            height: 40px;
            background: rgb(222, 229, 234);
            color: rgb(95, 105, 112);
            svg {
              margin: auto;
            }
          }
        }
        &.category .cont {
          position: relative;
          .categories {
            position: absolute;
            top: 100%;
            transform: translateY(10px);
            left: 0;
            width: 100%;
            border: 1px solid rgb(232, 232, 232);
            border-radius: 10px;
            background: #fff;
            box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
            z-index: 5;
            padding: 5px 0;
            li {
              padding: 5px 10px;
              transition: 0.3s;
              &.active {
                color: rgb(37, 93, 172);
              }
              &:hover {
                background: #efefef;
              }
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
          .selection {
            border: 1px solid rgb(232, 232, 232);
            height: 40px;
            padding: 0px 20px;
            width: 100%;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span {
              color: rgb(37, 93, 172);
            }
            .placeholder {
              color: rgb(131, 131, 131);
            }
          }
        }
        .tags {
          margin-top: 10px;
          display: flex;
          flex-wrap: wrap;
          gap: 10px 20px;
          font-size: 14px;
          > div {
            display: flex;
            align-items: center;
            height: 24px;
            background: #efefef;
            padding: 0 15px;
            border-radius: 15px;
            gap: 5px;
          }
          button {
            svg {
              margin: auto;
            }
          }
        }
        &.options {
          position: relative;
          width: 100%;
          overflow-x: hidden;
          .setting {
            background: rgb(222, 229, 234);
            color: rgb(95, 105, 112);
            padding: 0px 10px;
            min-width: 50px;
            font-weight: 700;
            border-radius: 5px;
            border: none;
            height: 33px;
            font-size: 14px;
            display: flex;
            align-items: center;
            gap: 5px;
            svg {
              margin: 0;
            }
          }
          .opt {
            margin-top: 10px;
          }
          .opt-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 5px;
            touch-action: none;
            user-select: none;
            &:last-child {
              margin-bottom: 0;
            }
            button {
              color: rgb(106, 106, 106);
              font-size: larger;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .contents > ul {
      width: calc(100% - 160px);
    }
  }
  @media screen and (max-width: 767px) {
    .contents {
      padding: 10px;
      display: block;
      height: calc(100% - 51px);
      font-size: 14px;
      > ul {
        width: 100%;
        padding: 10px;
        > li {
          display: block;
          .tit {
            width: 100%;
            display: block;
            margin-bottom: 5px;
          }
          .cont {
            width: 100%;
          }
          &.media .cont {
            > div,
            label {
              width: calc((100% - 30px) / 4);
              height: auto;
              aspect-ratio: 1;
            }
          }
        }
      }
    }
  }
`;

export const ProductPreviewContainer = styled.div`
  border-left: 1px solid #666;
  position: relative;
  width: 300px;
  height: 100%;
  transition: 0.3s;
  z-index: 10;
  background: #efefef;
  overflow-y: auto;
  border-radius: 0 0 30px 0;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #5a5a5a;
    border-radius: 10px;
    border: 2px solid #d9d9d9;
  }
  &::-webkit-scrollbar-track {
    background-color: #d9d9d9;
    border-radius: 10px;
  }
  .tit {
    color: #5f6970;
    border-color: #e8e8e8;
    border-bottom: 1px solid #666;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-weight: 700;
    background: #fff;
  }
  .cont {
    margin-bottom: 20px;
    img {
      width: 100%;
      aspect-ratio: 2 / 1;
      object-fit: contain;
      background: #fff;
    }
    .board {
      background: #fff;
      padding: 20px;
      .name,
      .price {
        font-weight: 700;
      }
      .name {
        font-size: 20px;
      }
      .desc {
        display: block;
        color: #6a6a6a;
        font-size: 14px;
        margin: 14px 0;
      }
      .price {
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        font-weight: 700;
      }
    }
  }
  .options {
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    .opt {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    p {
      margin-bottom: 14px;
      strong {
        display: inline-block;
        font-size: 20px;
        margin-right: 13px;
      }
      span {
        font-size: 12px;
        color: #6a6a6a;
      }
    }
    li {
      margin-bottom: 10px;
      color: #333;
      display: flex;
      justify-content: space-between;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    width: 260px;
    border-radius: 15px;
    .tit {
      height: 50px;
      line-height: 50px;
    }
    .cont {
      .board {
        .name,
        .price {
          font-size: 16px;
        }
        .desc {
          font-size: 12px;
        }
      }
    }
    .options {
      p strong {
        font-size: 16px;
      }
      li span {
        font-size: 12px;
      }
    }
  }
`;

export const DetailContainer = styled.div`
  height: 100%;
  font-size: 16px;
  .contents {
    padding: 15px;
    > ul {
      height: 100%;
      padding: 15px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #5a5a5a;
        border-radius: 10px;
        border: 2px solid #d9d9d9;
      }
      &::-webkit-scrollbar-track {
        background-color: #d9d9d9;
        border-radius: 10px;
      }
      > li {
        display: flex;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #efefef;
        gap: 20px;
        align-items: center;
        &:first-child {
          border-top: 1px solid #efefef;
          padding-top: 20px;
        }
        &:last-child {
          margin-bottom: 0;
        }
        &.media {
          .cont {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
          }
          img {
            width: calc((100% - 60px) / 7);
            aspect-ratio: 1;
            object-fit: cover;
            border: 1px solid #e8e8e8;
            border-radius: 5px;
          }
        }
        &.description {
          img {
            max-width: 100%;
          }
        }
        &.options {
          .opt {
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 0;
            }
            ul {
              margin-top: 5px;
              li {
                display: flex;
                align-items: center;
                justify-content: space-between;
                strong {
                  font-weight: normal;
                }
                span {
                  color: #b9b9b9;
                }
              }
            }
          }
        }
        .tit {
          font-weight: 700;
          width: 130px;
          color: #838383;
        }
        .cont {
          width: calc(100% - 150px);
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .contents ul li.media img {
      width: calc((100% - 40px) / 5);
    }
  }
  @media screen and (max-width: 767px) {
    .contents ul li {
      font-size: 14px;
      display: block;
      .tit,
      .cont {
        width: 100%;
      }
      .tit {
        margin-bottom: 5px;
        display: block;
      }
      &.media img {
        width: calc((100% - 20px) / 3);
      }
      &.description .cont {
        padding: 0;
        border: none;
      }
    }
  }
`;

export const OptionsContainer = styled.div`
  .contents {
    padding: 15px;
    font-size: 16px;
    .optionGroups {
      height: 100%;
      overflow-y: auto;
      padding: 15px;
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #5a5a5a;
        border-radius: 10px;
        border: 2px solid #d9d9d9;
      }
      &::-webkit-scrollbar-track {
        background-color: #d9d9d9;
        border-radius: 10px;
      }
      > li {
        margin-bottom: 50px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .option {
        font-size: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        position: relative;
        .name {
          font-weight: 700;
          display: block;
        }
      }
      .required,
      .products {
        display: flex;
        align-items: flex-start;
        color: #838383;
        gap: 10px;
        margin-bottom: 10px;
        .tit {
          gap: 10px;
          width: 120px;
          font-weight: 700;
          display: flex;
          align-items: center;
        }
      }
      .required .cont {
        max-width: calc(100% - 120px);
      }
      .products {
        .cont {
          max-width: calc(100% - 200px);
        }
        button {
          max-width: 70px;
          height: max-content;
          font-weight: 700;
        }
      }
      .options {
        margin-top: 20px;
        border: 1px solid #d1d1d1;
        padding: 20px;
        border-radius: 15px;
        > li {
          margin-bottom: 15px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          &:last-child {
            margin-bottom: 0;
          }
          span {
            display: block;
            &.value {
              font-size: 18px;
              font-weight: 700;
              margin-bottom: 5px;
            }
            &:not(.value) {
              color: #999;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .contents {
      .optionGroups .option {
        font-size: 20px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .contents {
      font-size: 14px;
      padding: 10px;
      .optionGroups {
        padding: 10px;
        .option {
          font-size: 20px;
        }
        .required,
        .products {
          display: block;
          .tit,
          .cont {
            max-width: 100%;
          }
          .cont {
            margin-top: 5px;
          }
        }
        .products {
          .cont span {
            display: block;
          }
          button {
            padding: 0px 10px;
            min-width: 50px;
            font-weight: 700;
            border-radius: 5px;
            border: none;
            height: 33px;
            font-size: 14px;
            background: rgb(222, 229, 234);
            color: rgb(95, 105, 112);
            margin-top: 10px;
          }
        }
        .options {
          border-radius: 10px;
          padding: 10px;
          > li {
            display: block;
            > div:last-child {
              margin-top: 5px;
            }
            span.value {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
`;

export const ActionButtonContainer = styled.div`
  font-size: 16px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  height: 30px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: fit-content;
  color: #696969;
  &.highlight {
    background: #333;
    button {
      color: #fff;
    }
  }
  > button {
    background: transparent;
    border: none;
    height: 30px;
    &.status {
      width: 90px;
      padding: 0 5px;
    }
    &.actions {
      width: 30px;
      height: 100%;
      border-left: 1px solid #e8e8e8;
      svg {
        margin: auto;
      }
    }
  }
  ul {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100px;
    transform: translateY(5px);
    background: #fff;
    border: 1px solid #bdbdbd;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    z-index: 10;
    &.context-actions {
      transform: translateY(5px) translateX(-100%);
      left: 100%;
    }
    li {
      font-size: 14px;
      background: transparent;
      border: none;
      height: 30px;
      line-height: 30px;
      transition: 0.3s;
      text-align: center;
      &.active,
      &:hover {
        background: #255dac;
        color: #fff;
      }
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const Modal = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
  .closeModal {
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
    transform: translateY(-100%);
    font-size: 60px;
  }
  .modal {
    max-width: 500px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border: 1px solid #a6a6a6;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 30px;
    box-sizing: border-box;
    width: 100%;
    height: 700px;
    max-height: 80vh;
    z-index: 33;
    &:not(.order):not(.product):not(.bizTime) > div {
      > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
    &.bizTime {
      padding: 0;
      max-width: 1000px;
    }
    &.product {
      padding: 0;
      max-width: 1000px;
    }
    &.order {
      padding: 0;
    }
    .label {
      font-size: 24px;
      height: 30px;
      margin-bottom: 20px;
      display: block;
      font-weight: 700;
      &:not(:first-child) {
        margin-top: 20px;
      }
    }
    > div {
      font-size: 16px;
    }
    .submit {
      width: 200px;
      display: block;
      margin: 0 auto;
      height: 33px;
      margin-top: 20px;
      background: rgb(37, 93, 172);
      color: rgb(255, 255, 255);
      font-size: 14px;
      border-radius: 5px;
      font-weight: 700;
    }
  }
  @media screen and (max-width: 1050px) {
    .modal {
      border-radius: 15px;
      &.product {
        max-width: calc(100% - 40px);
      }
    }
  }
  @media screen and (max-width: 767px) {
    .modal {
      width: calc(100% - 40px);
      .closeModal {
        display: none;
      }
      .label {
        font-size: 18px;
        height: 23px;
        margin-bottom: 10px;
      }
      > div {
        font-size: 14px;
      }
      .option {
        > div {
          margin-bottom: 5px;
        }
        span {
          &.tit,
          &.cont {
            display: block;
            width: 100%;
          }
        }
      }
    }
  }
`;

export const ProductManagerContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const LinkProductsContainer = styled.div`
  height: 100%;
  position: relative;
  padding: 20px;
  .search {
    margin-bottom: 20px;
  }
  .option {
    > div {
      display: flex;
      min-height: 20px;
    }
    span {
      display: inline-block;
      color: #838383;
      &.tit {
        width: 120px;
        font-weight: 700;
      }
      &.cont {
        width: calc(100% - 120px);
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .products {
    height: calc(100% - 220px);

    ul {
      height: calc(100% - 53px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #5a5a5a;
        border-radius: 10px;
        border: 2px solid #d9d9d9;
      }
      &::-webkit-scrollbar-track {
        background-color: #d9d9d9;
        border-radius: 10px;
      }
      li {
        color: #838383;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        img {
          width: 50px;
          height: 50px;
          object-fit: cover;
          border-radius: 10px;
        }
        .productInfo {
          width: calc(100% - 120px);
          span {
            display: block;
            &.name {
              font-weight: 700;
            }
            &:nth-child(1) {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .option > div {
      min-height: 18px;
    }
    .products {
      height: calc(100% - 185px);
      ul li {
        label {
          width: 20px;
          height: 20px;
        }
        .checkmark {
          width: 7px;
          height: 13px;
        }
        .productInfo {
          width: calc(100% - 100px);
        }
      }
    }
  }
`;

export const CustomLabel = styled.label`
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  height: 30px;
  width: 30px;
  position: relative;
  display: inline-block;
  input[type="checkbox"] {
    display: none;
  }
  .checkmark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    width: 8px;
    height: 16px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transition: 0.1s;
  }
  input[type="checkbox"]:checked ~ .checkmark {
    border-color: #696969;
  }
`;

export const LinkOptionsContainer = styled.div`
  height: 100%;
  font-size: 16px;
  .contents {
    padding: 15px;
    > ul {
      height: 100%;
      padding: 15px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #5a5a5a;
        border-radius: 10px;
        border: 2px solid #d9d9d9;
      }
      &::-webkit-scrollbar-track {
        background-color: #d9d9d9;
        border-radius: 10px;
      }
      > li {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          p {
            display: flex;
            align-items: center;
            gap: 5px;
            width: calc(100% - 20px);
            margin-bottom: 10px;
            span {
              font-weight: 700;
              font-size: 18px;
              width: calc(100% - 35px);
            }
          }
          button {
            transition: 0.3s;
            &.active {
              transform: rotate(180deg);
            }
          }
        }
        ul {
          transition: 0.3s;
          &.inactive {
            opacity: 0;
            overflow: hidden;
            max-height: 0;
          }
          &.active {
            opacity: 1;
            transform: scale(1);
          }
          li {
            color: #838383;
            margin-bottom: 5px;
            display: grid;
            grid-template-columns: 1fr auto;
            align-items: center;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
`;

export const MenuGroupsContainer = styled.div`
  .contents {
    padding: 15px;
    font-size: 16px;
    .menuGroups {
      height: 100%;
      overflow-y: auto;
      padding: 15px;
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #5a5a5a;
        border-radius: 10px;
        border: 2px solid #d9d9d9;
      }
      &::-webkit-scrollbar-track {
        background-color: #d9d9d9;
        border-radius: 10px;
      }
      > li {
        margin-bottom: 50px;
        &:last-child {
          margin-bottom: 0;
        }
        button.actions {
          /* border-left: none; */
        }
      }
      .menu {
        font-size: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        position: relative;
        .name {
          font-weight: 700;
          display: block;
        }
      }
      .products {
        margin-top: 20px;
        border: 1px solid #d1d1d1;
        padding: 20px;
        border-radius: 15px;
        > div {
          margin-bottom: 15px;
          display: flex;
          align-items: center;
          /* &:last-child {
            margin-bottom: 0;
          } */
          &.soldout img {
            filter: grayscale(100%);
          }
          &.available .tags span.status {
            color: rgb(255, 88, 88);
            background: rgba(255, 88, 88, 0.2);
          }
          /* button.actions {
            border-left: none;
          } */
          .productInfo {
            width: calc(100% - 30px);
            display: flex;
            align-items: center;
            gap: 10px;
            img {
              width: 90px;
              height: 90px;
              object-fit: cover;
              background: rgb(239, 239, 239);
              border-radius: 5px;
            }
            div {
              width: calc(100% - 100px);
            }
          }
          .tags {
            display: flex;
            gap: 5px;
            span {
              font-size: 12px;
              padding: 2px 5px;
              border-radius: 5px;
              color: rgb(85, 85, 85);
              background: rgb(238, 238, 238);
              &.inactive {
                background: rgb(51, 51, 51);
                color: rgb(255, 255, 255);
              }
            }
          }
          span {
            display: block;
            margin-bottom: 3px;
            &.name {
              font-size: 18px;
              font-weight: 700;
            }
            &.shortDescription,
            &.quantity {
              color: #999;
              font-size: 14px;
            }
            &.price {
              font-size: 14px;
            }
            &.price {
              font-weight: 700;
            }
            &.quantity {
              /* margin-right: 5px; */
            }
          }
        }
        .add {
          background: rgb(222, 229, 234);
          color: rgb(95, 105, 112);
          padding: 0px 10px;
          min-width: 50px;
          font-weight: 700;
          border-radius: 5px;
          border: none;
          height: 33px;
          font-size: 14px;
          margin: 0 auto;
          display: block;
          transition: 0.3s;
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .contents {
      .menuGroups .name {
        font-size: 20px;
      }
    }
  }

  @media screen and (max-width: 767px) {
    .contents {
      font-size: 14px;
      padding: 10px;
      .menuGroups {
        padding: 10px;
        .products {
          padding: 10px;
          border-radius: 10px;
          > div {
            display: block;
            position: relative;
            .productInfo {
              width: 100%;
              display: block;
              img {
                margin-bottom: 5px;
              }
              > div {
                width: 100%;
              }
              span {
                margin-bottom: 0;
                &.name {
                  font-size: 16px;
                }
              }
            }
            > div:last-child {
              position: absolute;
              top: 0;
              right: 0;
            }
          }
          button.add {
            width: 100%;
          }
        }
      }
    }
  }
`;

export const MenuGroupFormContainer = styled.div`
  height: 100%;
  font-size: 16px;
  .contents {
    position: relative;
    display: flex;
    > ul {
      width: calc(100% - 300px);
      li {
        &.products {
          align-items: flex-start;
          .tit {
            height: 40px;
            line-height: 40px;
          }
          .setting {
            background: rgb(222, 229, 234);
            color: rgb(95, 105, 112);
            padding: 0px 10px;
            min-width: 50px;
            font-weight: 700;
            border-radius: 5px;
            border: none;
            height: 33px;
            font-size: 14px;
            display: flex;
            align-items: center;
            gap: 5px;
            svg {
              margin: 0;
            }
          }
          .menus {
            margin-top: 10px;
            li {
              margin-bottom: 5px;
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
  }

  @media screen and (max-width: 767px) {
    font-size: 14px;
    .contents {
      height: calc(100% - 52px);
      display: block;
      > ul {
        width: 100%;
      }
    }
  }
`;

export const MenuGroupPreviewContainer = styled.div`
  border-left: 1px solid #666;
  position: relative;
  width: 300px;
  height: 100%;
  transition: 0.3s;
  z-index: 10;
  background: #efefef;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #5a5a5a;
    border-radius: 10px;
    border: 2px solid #d9d9d9;
  }
  &::-webkit-scrollbar-track {
    background-color: #d9d9d9;
    border-radius: 10px;
  }
  .tit {
    color: #5f6970;
    border-color: #e8e8e8;
    border-bottom: 1px solid #666;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-weight: 700;
    background: #fff;
  }
  .products {
    background: #fff;
    > span {
      display: block;
      font-weight: 700;
      font-size: 20px;
      border-bottom: 1px solid #aaa;
      padding: 20px;
      min-height: 65px;
    }
    .product {
      display: flex;
      align-items: center;
      padding: 10px;
      gap: 10px;
      img {
        width: 70px;
        aspect-ratio: 1;
        object-fit: cover;
        background: #fff;
        border: 1px solid #aaa;
        border-radius: 10px;
      }
      .info {
        width: calc(100% - 80px);
        span {
          display: block;
          &.name {
            font-size: 16px;
            font-weight: 700;
          }
          &.shortDescription {
            color: #6a6a6a;
          }
          &.price {
            font-weight: 500;
          }
          &.shortDescription,
          &.price {
            font-size: 14px;
          }
        }
      }
    }
  }
`;

export const PreviewContainer = styled.div`
  .company {
    .mySwiper {
      width: 100%;
      aspect-ratio: 2 / 1;
    }
    .box {
      width: 100%;
      height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      margin-bottom: 10px;
    }
    p {
      padding: 10px 20px;
      font-size: 22px;
      font-weight: 800;
    }
  }
  .tags {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
    font-size: 12px;
    margin-bottom: 10px;
    strong {
      font-weight: 700;
      background: #f2aa27;
      color: #fff;
      padding: 6px 16px;
      border-radius: 14px;
      font-size: 12px;
    }
    span {
      padding: 6px 16px;
      border-radius: 14px;
      &.cmpnySe {
        background: #f2aa27;
        color: #fff;
      }
      &.badge {
        font-weight: 700;
        color: #f06e96;
        background: rgba(240, 110, 150, 0.2);
        &:nth-child(3) {
          color: #42ad7a;
          background: rgba(66, 173, 122, 0.2);
        }
      }
    }
  }
`;

export const MenuBoardDetails = styled.div`
  padding: 20px;
  font-size: 14px;
  .section {
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    h3 {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 10px;
    }
    p {
      white-space: pre-line;
    }
  }
`;

export const MenuContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 50px;
  letter-spacing: -1px;
  .preview {
    width: 100%;
    max-width: 390px;
    height: calc(100% - 170px);
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  }
  .slideWrapper {
    height: auto;
    .slideContent {
      width: 100%;
      transition: transform 0.3s ease;
    }
    .slideContent.inactive {
      position: absolute;
      opacity: 0;
      z-index: -1;
      pointer-events: none;
    }
    .slideContent.active {
      position: relative;
      opacity: 1;
      z-index: 1;
    }
  }
  .actions {
    width: 390px;
    button {
      width: calc(50% - 10px);
      height: 44px;
      border-radius: 10px;
      border: none;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
      font-weight: 700;
      font-size: 16px;
      &:first-child {
        background: #fff;
      }
      &:last-child {
        margin-left: 20px;
        background: #f2aa27;
      }
    }
  }
  .category {
    font-size: 16px;
    font-weight: 700;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    ul {
      display: flex;
      align-items: center;
      padding: 0 20px;
      gap: 20px;
      height: 50px;
      border-bottom: 1px solid #ebebeb;
      min-width: 100%;
      width: max-content;
    }
  }
  .menuGroup {
    min-height: 200px;
    > li {
      padding: 30px 20px;
      p {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 20px;
      }
      ul {
        font-size: 16px;
        li {
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 20px;
          &.soldout img {
            filter: grayscale(100%);
          }
          &.soldout .status,
          &.low .status {
            color: #555;
            background: #eee;
          }
          &.available .status {
            color: rgb(255, 88, 88);
            background: rgba(255, 88, 88, 0.2);
          }
          img {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            border: 1px solid #ccc;
          }
          span {
            display: block;
            &.status {
              width: fit-content;
              padding: 1px 5px;
              font-size: 13px;
              margin-bottom: 5px;
              border-radius: 2px;
            }
            &.shortDescription {
              color: #b1b1b1;
              font-size: 14px;
            }
            &.name,
            &.price {
              font-weight: 700;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .images {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    font-size: 16px;
    img {
      width: calc(50% - 10px);
      aspect-ratio: 1;
      border: 1px solid #ccc;
      object-fit: cover;
      border-radius: 10px;
    }
  }
  p.text {
    padding: 20px;
    font-size: 16px;
  }

  @media screen and (max-width: 767px) {
    gap: 0;
    display: block;
    .preview {
      width: 100%;
      box-shadow: none;
      height: 100%;
      padding-bottom: 100px;
      margin: 0 auto;
    }
    .actions {
      max-width: 350px;
      width: calc(100% - 80px);
      position: fixed;
      bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
      button {
        font-size: 14px;
        width: calc(50% - 5px);
        &:last-child {
          margin-left: 10px;
        }
      }
    }
    .menuGroup > li {
      padding: 20px;
      ul li {
        gap: 10px;
        font-size: 14px;
        span.status {
          font-size: 12px;
          margin-bottom: 4px;
        }
        .productInfo {
          width: calc(100% - 90px);
        }
        img {
          width: 80px;
          height: 80px;
        }
      }
    }
    .category {
      font-size: 14px;
    }
  }
`;

export const CompanyFormContainer = styled.div`
  height: 100%;
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  > ul {
    width: calc(100% - 300px);
    li {
      .tags {
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
        gap: 10px 20px;
        font-size: 14px;
        > div {
          display: flex;
          align-items: center;
          height: 24px;
          background: #efefef;
          padding: 0 15px;
          border-radius: 15px;
          gap: 5px;
        }
        button {
          svg {
            margin: auto;
          }
        }
      }
      &.cmpnyImage .cont {
        display: flex;
        gap: 10px;
        overflow-x: auto;
        overflow-y: hidden;
        user-select: none;
        &::-webkit-scrollbar {
          width: 0;
        }
        .banners {
          display: flex;
          gap: 10px;
        }
        .box,
        label {
          width: 250px;
          aspect-ratio: 2 / 1;
          border-radius: 5px;
          border: 1px solid #e8e8e8;
          position: relative;
          margin: 0;
          max-width: 300px;
        }
        button {
          min-width: auto;
          height: auto;
          padding: 0;
          position: absolute;
          top: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          border: none;
          font-size: 16px;
          svg {
            display: block;
            margin: 0;
          }
        }
        img,
        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        label {
          font-size: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #838383;
          svg {
            display: block;
            margin: 0;
          }
        }
        input[type="file"] {
          display: none;
        }
      }
      &.adres .cont {
        button {
          padding: 0 10px;
          min-width: 50px;
          font-weight: 700;
          border-radius: 5px;
          border: none;
          height: 33px;
          font-size: 14px;
          transition: 0.3s;
          background: #dee5ea;
          color: #5f6970;
          svg {
            display: block;
            margin: auto;
          }
        }
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        input:nth-child(2) {
          width: calc(100% - 110px);
        }
        button {
          height: 40px;
          width: 100px;
        }
      }
      .check {
        display: flex;
        align-items: center;
        gap: 10px;
        strong {
          display: block;
        }
      }
      &.badges,
      &.bizTime {
        button {
          margin-bottom: 10px;
          background: rgb(222, 229, 234);
          color: rgb(95, 105, 112);
          padding: 0px 10px;
          min-width: 50px;
          font-weight: 700;
          border-radius: 5px;
          border: none;
          height: 33px;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 5px;
          svg {
            margin: 0;
          }
        }
      }
      &.badges {
        div span {
          margin-left: 10px;
          font-size: 14px;
          padding: 6px 16px;
          border-radius: 14px;
          color: #f06e96;
          background: rgba(240, 110, 150, 0.2);
          width: fit-content;
          &:first-child {
            margin-left: 0;
          }
        }
      }
      &.logoImage .cont {
        position: relative;
        label {
          max-width: 400px;
          width: 100%;
          max-height: 200px;
          aspect-ratio: 2 / 1;
          border: 1px solid #e8e8e8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          input[type="file"] {
            display: none;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      &.time {
        .cont > div {
          max-width: 700px;
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
          .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .label {
              height: auto;
              margin-bottom: 0;
            }
            button {
              height: 30px;
            }
          }
          .timeField {
            margin: 10px 0;
            display: flex;
            align-items: center;
            gap: 10px;
            height: 40px;
            > div {
              width: calc(50% - 10px);
              display: flex;
              align-items: center;
              justify-content: space-between;
              border: 1px solid rgb(232, 232, 232);
              overflow: hidden;
              border-radius: 10px;
            }
            input[type="text"] {
              border: none;
              &:focus {
                border: none !important;
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1050px) {
    > ul {
      padding: 20px;
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 14px;
    padding: 10px;
    height: calc(100% - 51px);
    > ul {
      width: 100%;
      padding: 10px;
      li.cmpnyImage .cont {
        .mySwiper {
          width: 100%;
        }
        label {
          height: 33px;
          width: 100px;
          background: rgb(222, 229, 234);
          color: rgb(95, 105, 112);
          font-size: 24px;
        }
      }
      li.badges div span {
        display: block;
        margin-left: 0;
        margin-bottom: 5px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .ck-editor__editable {
      min-height: 250px !important;
      overflow-y: auto;
    }
  }
`;

export const BadgesModalContainer = styled.div`
  font-size: 16px;
  padding: 20px;
  .badges {
    height: calc(100% - 103px);
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #5a5a5a;
      border-radius: 10px;
      border: 2px solid #d9d9d9;
    }
    &::-webkit-scrollbar-track {
      background-color: #d9d9d9;
      border-radius: 10px;
    }
    span {
      display: inline-block;
      margin: 5px 5px 5px 0;
      padding: 5px 10px;
      background: #efefef;
      border-radius: 15px;
      transition: 0.3s;
      &.active {
        color: #f06e96;
        background: rgba(240, 110, 150, 0.2);
      }
    }
  }
`;

export const SearchContainer = styled.div`
  font-size: 16px;
  position: relative;
  input[type="text"] {
    width: calc(100% - 60px);
    padding: 0px 40px 0 5px;
    border: 1px solid rgb(102, 102, 102);
    border-radius: 5px;
    height: 33px;
    margin-right: 10px;
    &:focus {
      border: 1px solid rgb(102, 102, 102) !important;
      box-shadow: none;
    }
  }
  svg {
    display: block;
    margin: auto;
  }
  .reset {
    position: absolute;
    top: 50%;
    background: rgb(222, 229, 234);
    color: rgb(95, 105, 112);
    border-radius: 50%;
    transform: translateY(-50%);
    right: 70px;
    border: none;
    width: 20px;
    height: 20px;
    min-width: auto;
    padding: 0;
  }
  .searched {
    width: 50px;
    height: 33px;
    background: #255dac;
    color: #fff;
    border: none;
    border-radius: 5px;
  }
  @media screen and (max-width: 767px) {
    .search {
      font-size: 14px;
      input[type="text"] {
        height: 30px;
      }
      .searched {
        height: 30px;
      }
    }
  }
`;

export const TooltipContainer = styled.span`
  display: flex;
  gap: 5px;
  align-items: center;
  position: relative;
  span {
    display: block;
    background: #333;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    line-height: 20px;
    text-align: center;
    color: #fff;
  }
  span:hover ~ .tooltip-box {
    opacity: 1;
    transform: scale(1);
    padding: 20px;
  }
  > .tooltip-box {
    width: 250px;
    opacity: 0;
    transform: scale(0);
    position: absolute;
    top: 100%;
    left: 0;
    background: #fff;
    font-weight: normal;
    transition: 0.3s;
    z-index: 10;
    border-radius: 10px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    p {
      font-size: 14px;
      white-space: pre-line;
    }
    > div {
      margin-bottom: 5px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

export const OrderGroupContainer = styled.div`
  height: 100%;
  .contents {
    height: calc(100% - 70px);
    padding: 15px;
    > ul {
      padding: 15px;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #5a5a5a;
        border-radius: 10px;
        border: 2px solid #d9d9d9;
      }
      &::-webkit-scrollbar-track {
        background-color: #d9d9d9;
        border-radius: 10px;
      }
      li {
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .overlay {
      background: #fff;
      box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
      position: absolute;
      background: #fff;
      max-width: 100%;
      border-radius: 5px;
      padding: 10px;
      pointer-events: none;
      z-index: 999;
    }
  }
  @media screen and (max-width: 767px) {
    .contents {
      padding: 10px;
      > ul {
        padding: 10px;
      }
    }
  }
`;

export const BizTimeFormContainer = styled.div`
  display: flex;
  height: calc(100% - 73px);
  overflow: hidden;
  font-size: 16px;
  > ul {
    width: calc(100% - 300px);
  }
  .timeInputGroup {
    .cont > div {
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .label {
        height: auto;
        margin-bottom: 0;
        font-size: 16px;
      }
      button {
        padding: 0 10px;
        height: 33px;
        background: rgb(51, 51, 51);
        color: rgb(255, 255, 255);
        border-radius: 5px;
        font-weight: 700;
        font-size: 14px;
        transition: 0.3s;
        &.active {
          background: rgb(222, 229, 234);
          color: rgb(95, 105, 112);
        }
      }
    }
    .closed {
      color: #999;
    }
    .check {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    .timeField {
      margin: 10px 0;
      display: flex;
      align-items: center;
      gap: 10px;
      height: 40px;
      > div {
        width: calc(50% - 10px);
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid rgb(232, 232, 232);
        overflow: hidden;
        border-radius: 10px;
      }
      &.is24Hours {
        height: 40px;
        border: 1px solid rgb(232, 232, 232);
        overflow: hidden;
        border-radius: 10px;
        input[type="text"] {
          width: 100%;
        }
      }
      input[type="text"] {
        border: none;
        width: 50%;
        text-align: center;
        &:focus {
          border: none !important;
          box-shadow: none;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    > ul {
      width: 100%;
    }
  }
`;

export const CompanyPreviewContainer = styled.div`
  border-left: 1px solid #666;
  position: relative;
  width: 300px;
  height: 100%;
  transition: 0.3s;
  z-index: 10;
  background: #efefef;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #5a5a5a;
    border-radius: 10px;
    border: 2px solid #d9d9d9;
  }
  &::-webkit-scrollbar-track {
    background-color: #d9d9d9;
    border-radius: 10px;
  }
  .tit {
    color: #5f6970;
    border-color: #e8e8e8;
    border-bottom: 1px solid #666;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-weight: 700;
    background: #fff;
  }
  .tit ~ div {
    background: #fff;
    display: block;
    font-size: 20px;
    border-bottom: 1px solid rgb(170, 170, 170);
    padding-bottom: 20px;
    min-height: 65px;
  }
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const MenuBoardTabMenu = styled.ul`
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #d0962d;
  font-size: 16px;
  display: flex;
  float: none;
  gap: 20px;
  background: #fff;
  &.center {
    justify-content: center;
  }
  li {
    padding: 0 20px;
    font-weight: 700;
    text-align: center;
    &.active {
      border-bottom: 2px solid #d0962d;
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const MenuBoardStoreInfo = styled.div`
  padding: 20px;
  strong {
    font-weight: 700;
    background: #f2aa27;
    color: #fff;
    padding: 6px 16px;
    border-radius: 14px;
    font-size: 12px;
    width: 80px;
    text-align: center;
  }
  div {
    display: flex;
    align-items: center;
    gap: 30px;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    .cont {
      font-weight: normal;
      font-size: 16px;
      width: calc(100% - 110px);
    }
    span {
      display: block;
    }
  }
`;
